import { Toaster } from "@/components/ui/sonner";
import useLenis from "./hooks/useLenis";
import Loader from "./components/Loader";
import CustomCursor from "./components/CustomCursor";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import ArtistFeature from "./components/ArtistFeature";
import Music from "./components/Music";
import Visuals from "./components/Visuals";
import Archive from "./components/Archive";
import Objects from "./components/Objects";
import Transmissions from "./components/Transmissions";
import Statement from "./components/Statement";
import Connect from "./components/Connect";
import Community from "./components/Community";
import Footer from "./components/Footer";
import ListenDock from "./components/ListenDock";
import OwnMusic from "./components/OwnMusic";
import PaymentReturn from "./components/PaymentReturn";
import Dashboard from "./components/Dashboard";

export default function App() {
  useLenis();

  return (
    <div className="relative bg-[color:var(--void)] min-h-screen antialiased">
      <div className="grain-overlay" aria-hidden />
      <CustomCursor />
      <Loader />
      <PaymentReturn />
      <Dashboard />

      <Nav />
      <main>
        <Hero />
        <Marquee />
        <ArtistFeature />
        <Music />
        <OwnMusic />
        <Visuals />
        <Archive />
        <Objects />
        <Transmissions />
        <Statement />
        <Connect />
        <Community />
      </main>
      <Footer />

      <ListenDock />

      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(10,11,13,0.9)",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#e9ebef",
            backdropFilter: "blur(18px)",
            fontFamily: "Archivo, sans-serif",
          },
        }}
      />
    </div>
  );
}
